import React, { useCallback, useEffect, useState } from 'react';
import Panel from 'components/Panel';
import Break from 'components/Break';
import { BlueBorderButton, BlueButton } from 'components/Button';
import Text from 'components/Text';
import SectionHeader from 'components/Panels/SectionHeader';
import {
  SubPanel,
  SubPanelRow,
  PanelRowDescriptor,
  PanelRowDisplay,
  PanelRowTextForm,
  PanelButtonRow,
  StyledForm,
  PanelContent,
  FullPanel
} from 'components/PanelComponents';
import { useDispatch, useSelector } from 'react-redux';
import { editTopoNode } from 'reducers/toponode/actions';
import { revertSidePanel } from 'reducers/sidePanel/actions';
import { LOCAL_RESOURCE_MAPPED_VALUES } from 'utils/appConstants';
import Table from 'components/Table';

const childrenNodeColumnDefs = [
  {
    headerName: 'ID',
    field: 'topoNodeId'
  },
  {
    headerName: 'Description',
    field: 'description'
  }
];

const AddChildrenNode = ({ isActive }) => {
  const topoNodes = useSelector(state => state.topoNode.topoNodes);
  const parentTopoNodeId = useSelector(
    state => state.sidePanel.data.parentTopoNodeId
  );
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');
  const [selectedNode, setSelectedNode] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (name === 'searchInput') setSearchInput(value);
  };

  const handleSubmit = async e => {
    try {
      e.preventDefault();
      const parentNodeInfo = topoNodes.find(
        topoNode => topoNode.topoNodeId === parentTopoNodeId
      );
      const currentNodeInfo = topoNodes.find(
        topoNode => topoNode.topoNodeId === selectedNode
      );
      await dispatch(
        editTopoNode({
          ...currentNodeInfo,
          parentTopoNodeId: parentNodeInfo.topoNodeId
        })
      );
      dispatch(revertSidePanel());
    } finally {
      setIsSubmitting(false);
    }
  };

  const onSelectNode = useCallback(row => {
    const { topoNodeId } = row.data;
    setSelectedNode(topoNodeId);
  }, []);

  if (!isActive || (isActive && isLoading)) {
    return null;
  } else {
    let parentNodeInfo = topoNodes.find(
      topoNode => topoNode.topoNodeId === parentTopoNodeId
    );
    const childTopoNodeIds = parentNodeInfo.childTopoNodeIds;

    const ancestors = [];
    while (parentNodeInfo.parentTopoNodeId) {
      ancestors.push(parentNodeInfo.parentTopoNodeId);
      const parentId = parentNodeInfo.parentTopoNodeId;
      parentNodeInfo = topoNodes.find(
        topoNode => topoNode.topoNodeId === parentId
      );
    }

    const filteredData = topoNodes.filter(node => {
      return (
        childTopoNodeIds.indexOf(node.topoNodeId) < 0 &&
        node.localNode !== LOCAL_RESOURCE_MAPPED_VALUES.REMOTE &&
        ancestors.indexOf(node.topoNodeId) < 0 &&
        node.topoNodeId !== parentTopoNodeId &&
        (node.topoNodeId.toUpperCase().includes(searchInput.toUpperCase()) ||
          (node.description &&
            node.description.toUpperCase().includes(searchInput.toUpperCase())))
      );
    });
    return (
      <StyledForm onSubmit={handleSubmit}>
        <FullPanel>
          <Panel title="Selected Node » Add Existing Node" primaryHeader />
          <PanelContent>
            <SubPanel>
              <SubPanelRow>
                <PanelRowDescriptor>
                  <Text fontSize="12px">Current Node ID</Text>
                </PanelRowDescriptor>
                <PanelRowDisplay>
                  <Text fontSize="12px">{parentTopoNodeId}</Text>
                </PanelRowDisplay>
              </SubPanelRow>

              <Break margin="0 0 12px" />

              <SectionHeader
                header="Find TopoNode by Description, ID"
                marginBottom="8px"
              />
              <PanelRowTextForm
                name="searchInput"
                onChange={handleInputChange}
                value={searchInput}
                autocomplete="off"
                placeholder="Search..."
              />

              <Table
                rowData={filteredData}
                columnDefs={childrenNodeColumnDefs}
                height="300px"
                width="100%"
                padding="0px"
                margin="10px 0px"
                onRowClicked={onSelectNode}
              />
            </SubPanel>
          </PanelContent>
          <PanelButtonRow>
            <BlueBorderButton
              type="button"
              onClick={() => dispatch(revertSidePanel())}
            >
              Cancel
            </BlueBorderButton>
            <BlueButton type="submit" disabled={isSubmitting || !selectedNode}>
              Attach to Selected Node
            </BlueButton>
          </PanelButtonRow>
        </FullPanel>
      </StyledForm>
    );
  }
};

export default AddChildrenNode;
